import { IndustryItemInterface } from '../interfaces/industries';

export const IndustriesDataExampleRespnse: IndustryItemInterface[] = [
    {
        name: null,
        description: null,
        field_image: {
            alt: null,
            field_media_image: null,
        },
        connected_nodes: [
            {
                title: null,
                url: null,
            },
        ],
    },
];
